// Petra Fina: expose real color and size availability without forcing trial-and-error taps.
(function () {
  if (window.__petraVariantStockVisibility) return;
  window.__petraVariantStockVisibility = true;

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }

  function isColorOption(value) {
    var name = normalize(value);
    return name === 'cor' || name === 'color' || name === 'cores';
  }

  function isSizeOption(value) {
    var name = normalize(value);
    return name === 'tamanho' || name === 'size' || name === 'tam';
  }

  function parseProduct(root) {
    var raw = root.getAttribute('data-json-product');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (error) { return null; }
  }

  function loadProduct(root, card) {
    var parsed = parseProduct(root);
    if (parsed) return Promise.resolve(parsed);
    if (card) return Promise.resolve(null);
    var handle = root.getAttribute('data-product-handle');
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  function getIndexes(product) {
    var colorIndex = -1;
    var sizeIndex = -1;
    (product.options || []).forEach(function (option, index) {
      var optionName = option && option.name ? option.name : option;
      if (isColorOption(optionName)) colorIndex = index;
      if (isSizeOption(optionName)) sizeIndex = index;
    });
    return { color: colorIndex, size: sizeIndex };
  }

  function sizesForColor(product, indexes, color) {
    return (product.variants || [])
      .filter(function (variant) {
        return variant.available && normalize(variant.options[indexes.color]) === normalize(color);
      })
      .map(function (variant) { return variant.options[indexes.size]; })
      .filter(function (value, index, values) { return values.indexOf(value) === index; });
  }

  function colors(product, indexes) {
    return (product.options_with_values || product.options || []).map(function (option) { return option; });
  }

  function allColors(product, indexes) {
    return (product.variants || [])
      .map(function (variant) { return variant.options[indexes.color]; })
      .filter(function (value, index, values) { return values.indexOf(value) === index; });
  }

  function getColorSection(root) {
    var sections = root.querySelectorAll('.product-options__section[data-property]');
    for (var index = 0; index < sections.length; index += 1) {
      if (isColorOption(sections[index].getAttribute('data-property'))) return sections[index];
    }
    return null;
  }

  function selectedColor(root, product, indexes) {
    var preferred = root.getAttribute('data-petra-stock-color');
    var section = getColorSection(root);
    var active = section && section.querySelector('[data-js-option-value].active');
    var value = active && active.getAttribute('data-value');
    var availableColors = allColors(product, indexes);

    if (value) {
      return availableColors.find(function (color) { return normalize(color) === normalize(value); }) || value;
    }
    if (preferred) {
      return availableColors.find(function (color) { return normalize(color) === normalize(preferred); }) || preferred;
    }
    var firstAvailable = (product.variants || []).find(function (variant) { return variant.available; });
    return firstAvailable ? firstAvailable.options[indexes.color] : availableColors[0];
  }

  function setText(node, value) {
    if (node) node.textContent = value;
  }

  function createPdpBlock() {
    var block = document.createElement('div');
    block.className = 'petra-variant-stock';
    block.innerHTML = [
      '<p class="petra-variant-stock__selected"><span class="petra-variant-stock__label">Disponível em</span> <strong data-petra-stock-color></strong><span aria-hidden="true">:</span> <span data-petra-stock-sizes></span></p>',
      '<details class="petra-variant-stock__details">',
      '<summary>Ver disponibilidade por cor</summary>',
      '<div class="petra-variant-stock__matrix" data-petra-stock-matrix></div>',
      '</details>',
    ].join('');
    return block;
  }

  function createCardBlock() {
    var block = document.createElement('p');
    block.className = 'petra-card-stock';
    block.innerHTML = '<span class="petra-card-stock__label">Disponível em</span> <span data-petra-card-stock-sizes></span>';
    return block;
  }

  function renderMatrix(block, product, indexes) {
    var matrix = block.querySelector('[data-petra-stock-matrix]');
    if (!matrix) return;
    matrix.replaceChildren();
    allColors(product, indexes).forEach(function (color) {
      var row = document.createElement('div');
      row.className = 'petra-variant-stock__row';
      var colorName = document.createElement('span');
      colorName.className = 'petra-variant-stock__color';
      colorName.textContent = color;
      var sizes = sizesForColor(product, indexes, color);
      var value = document.createElement('span');
      value.className = 'petra-variant-stock__sizes';
      value.textContent = sizes.length ? sizes.join(' · ') : 'Esgotado';
      if (!sizes.length) row.classList.add('is-sold-out');
      row.append(colorName, value);
      matrix.appendChild(row);
    });
  }

  function markUnavailableColors(root, product, indexes) {
    var section = getColorSection(root);
    if (!section) return;
    section.querySelectorAll('[data-js-option-value]').forEach(function (option) {
      var rawValue = option.getAttribute('data-value');
      var hasStock = sizesForColor(product, indexes, rawValue).length > 0;
      option.classList.toggle('petra-color-unavailable', !hasStock);
      option.setAttribute('aria-label', rawValue + (hasStock ? ' disponível' : ' esgotado'));
      option.setAttribute('title', rawValue + (hasStock ? ' disponível' : ' esgotado'));
    });
  }

  function refreshPdp(root, product, indexes, block) {
    var color = selectedColor(root, product, indexes);
    var sizes = sizesForColor(product, indexes, color);
    setText(block.querySelector('[data-petra-stock-color]'), color || 'Cor selecionada');
    setText(block.querySelector('[data-petra-stock-sizes]'), sizes.length ? sizes.join(' · ') : 'Esgotado');
    block.classList.toggle('is-sold-out', !sizes.length);
    markUnavailableColors(root, product, indexes);
  }

  function refreshCard(root, product, indexes, block) {
    var color = selectedColor(root, product, indexes);
    var sizes = sizesForColor(product, indexes, color);
    setText(block.querySelector('[data-petra-card-stock-sizes]'), sizes.length ? sizes.join(' · ') : 'Esgotado');
    block.classList.toggle('is-sold-out', !sizes.length);
    block.setAttribute('aria-label', color + ': ' + (sizes.length ? sizes.join(', ') + ' disponíveis' : 'esgotado'));
    markUnavailableColors(root, product, indexes);
  }

  function initRoot(root) {
    if (root.dataset.petraStockReady) return;
    var card = root.closest('product-item') || root.classList.contains('product-collection');
    root.dataset.petraStockReady = 'pending';
    loadProduct(root, card).then(function (product) {
      if (!product) { delete root.dataset.petraStockReady; return; }
      var indexes = getIndexes(product);
      if (indexes.color < 0 || indexes.size < 0) { delete root.dataset.petraStockReady; return; }

      markUnavailableColors(root, product, indexes);

      root.dataset.petraStockReady = 'true';
      root.addEventListener('click', function (event) {
        if (!event.target.closest('[data-js-option-value]')) return;
        window.setTimeout(function () {
          markUnavailableColors(root, product, indexes);
        }, 50);
      });
    });
  }

  function injectStyle() {
    if (document.getElementById('petra-variant-stock-style')) return;
    var style = document.createElement('style');
    style.id = 'petra-variant-stock-style';
    style.textContent = [
      '.petra-variant-stock { margin: 10px 0 16px; border-top: 1px solid #e7dfdc; border-bottom: 1px solid #e7dfdc; }',
      '.petra-variant-stock__selected { margin: 0; padding: 10px 0; color: #241f21; font-size: 13px; line-height: 1.45; }',
      '.petra-variant-stock__label, .petra-card-stock__label { color: #746a6d; font-size: 11px; font-weight: 600; letter-spacing: .04em; text-transform: uppercase; }',
      '.petra-variant-stock__selected strong { font-weight: 600; }',
      '.petra-variant-stock__details { border-top: 1px solid #eee7e4; }',
      '.petra-variant-stock__details summary { display: flex; align-items: center; justify-content: space-between; min-height: 42px; cursor: pointer; color: #241f21; font-size: 12px; font-weight: 600; letter-spacing: .03em; list-style: none; }',
      '.petra-variant-stock__details summary::-webkit-details-marker { display: none; }',
      '.petra-variant-stock__details summary::after { content: "+"; font-size: 18px; font-weight: 400; }',
      '.petra-variant-stock__details[open] summary::after { content: "-"; }',
      '.petra-variant-stock__matrix { display: grid; gap: 7px; padding: 0 0 12px; }',
      '.petra-variant-stock__row { display: flex; justify-content: space-between; gap: 14px; padding-bottom: 7px; border-bottom: 1px solid #f1ecea; font-size: 12px; line-height: 1.3; }',
      '.petra-variant-stock__color { color: #342e30; font-weight: 600; }',
      '.petra-variant-stock__sizes { color: #655b5e; text-align: right; }',
      '.petra-variant-stock__row.is-sold-out .petra-variant-stock__color, .petra-variant-stock__row.is-sold-out .petra-variant-stock__sizes, .petra-variant-stock.is-sold-out [data-petra-stock-sizes] { color: #9a6d6d; text-decoration: line-through; }',
      '.petra-color-unavailable { opacity: .38 !important; position: relative; }',
      '.petra-color-unavailable::after { content: ""; position: absolute; left: 8%; top: 48%; width: 84%; height: 1px; background: #302a2c; transform: rotate(-45deg); transform-origin: center; pointer-events: none; }',
      '.petra-card-stock { margin: 0 0 8px; color: #373133; font-size: 12px; line-height: 1.35; }',
      '.petra-card-stock [data-petra-card-stock-sizes] { font-weight: 600; }',
      '.petra-card-stock.is-sold-out [data-petra-card-stock-sizes] { color: #9a6d6d; text-decoration: line-through; }',
      '@media (max-width: 767px) { .petra-variant-stock { margin: 10px 0 14px; } .petra-variant-stock__selected { font-size: 12px; } .petra-variant-stock__row { font-size: 11px; } .petra-card-stock { font-size: 11px; margin-bottom: 6px; } }',
    ].join('\n');
    document.head.appendChild(style);
  }

  function init() {
    injectStyle();
    document.querySelectorAll('[data-js-product][data-product-handle]').forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.setTimeout(init, 800);
  window.setTimeout(init, 2500);
})();
